/* eslint-disable react/prop-types */
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Link } from 'react-router-dom';
import { PRODUCT_NAME } from '@constants';
import classes from './Tab2.module.css';

import 'react-loading-skeleton/dist/skeleton.css';

export function ConnectionCardSkeleton({ cxname = '', css = {} }) {
  return (
    <div className={cx([classes.main_card], cxname)} style={css}>
      <Skeleton containerClassName={classes.mod_title} style={{ height: '100%', width: '100%' }} />
      <div className={classes.mod_content}>
        <Skeleton containerClassName={classes.mod_img} style={{ height: '100%', width: '100%' }} />
        <div className={classes.mod_info}>
          <div className={classes.mod_platform_name}>
            <Skeleton style={{ height: '100%', width: '50%' }} />
          </div>
          <div className={classes.mod_platform_info}>
            <Skeleton style={{ height: '100%', width: '60%' }} />
          </div>
        </div>
      </div>
    </div>
  );
}

function StoreActiveProducts({
  loading, products,
}) {
  if (loading) {
    return <ConnectionCardSkeleton />;
  }

  return (
    <div className={classes.products}>
      {/* <div className={classes.mod_title}>{(title || '').toUpperCase()}</div> */}
      {
        !products.length
          ? (
            <div className={classes.no_products}>
              No product here.
              <Link to="/products" className={classes.choose_text}>Please choose a Seel product.</Link>
            </div>
          )
          : products.map(({ name, icon }) => {
            const isRA = name === PRODUCT_NAME.RETURN_ASSURANCE;
            return (
              <div className={classes.product_wrapper} key={name}>
                <img className={classes.product_icon} src={icon} alt="" />
                <div className={classes.product_text}>{name}</div>
                {
                  isRA ? <a href="/ra/settings" className={classes.product_setting}>Settings</a> : (
                    <span className={classes.product_disabled}>
                      Settings
                    </span>
                  )
                }

              </div>
            );
          })
      }
    </div>
  );
}

export default StoreActiveProducts;

StoreActiveProducts.proptype = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    connected: PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      info: PropTypes.string.isRequired,
    }),
    empty: PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      info: PropTypes.string.isRequired,
      clickHandler: PropTypes.func.isRequired,
      emptyText: PropTypes.string.isRequired,
      buttonText: PropTypes.string.isRequired,
    }),
  }),
};
